var _rect, _circle, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _rect2, _g14, _g15, _rect3, _g16, _g17, _rect4, _g18, _g19, _rect5, _g20, _g21, _rect6, _g22, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 185,
    viewBox: "0 0 263 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2590_4847)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 263,
    height: 185,
    fill: "#111213"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 131,
    cy: 103,
    r: 38.7991,
    stroke: "url(#paint0_linear_2590_4847)",
    strokeWidth: 0.401822
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2590_4847)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 103,
    r: 76.7991,
    stroke: "url(#paint1_linear_2590_4847)",
    strokeOpacity: 0.5,
    strokeWidth: 0.401822,
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter1_d_2590_4847)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 103,
    r: 111.799,
    stroke: "url(#paint2_linear_2590_4847)",
    strokeOpacity: 0.3,
    strokeWidth: 0.401822,
    shapeRendering: "crispEdges"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_d_2590_4847)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 103,
    r: 135.799,
    stroke: "url(#paint3_linear_2590_4847)",
    strokeOpacity: 0.3,
    strokeWidth: 0.401822,
    shapeRendering: "crispEdges"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter3_d_2590_4847)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 103,
    r: 14,
    fill: "url(#paint4_linear_2590_4847)",
    fillOpacity: 0.4,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 103,
    r: 13.7991,
    stroke: "url(#paint5_linear_2590_4847)",
    strokeWidth: 0.401822,
    shapeRendering: "crispEdges"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_2590_4847)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 133,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#B6B8BB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.2009,
    y: 133.201,
    width: 9.59818,
    height: 9.59818,
    rx: 4.79909,
    stroke: "url(#paint6_linear_2590_4847)",
    strokeOpacity: 0.5,
    strokeWidth: 0.401822
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_2590_4847)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 40,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#B6B8BB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.2009,
    y: 40.2009,
    width: 9.59818,
    height: 9.59818,
    rx: 4.79909,
    stroke: "url(#paint7_linear_2590_4847)",
    strokeOpacity: 0.5,
    strokeWidth: 0.401822
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_2590_4847)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 68,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#B6B8BB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.201,
    y: 68.2009,
    width: 9.59818,
    height: 9.59818,
    rx: 4.79909,
    stroke: "url(#paint8_linear_2590_4847)",
    strokeOpacity: 0.5,
    strokeWidth: 0.401822
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_2590_4847)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 10,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#161718"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.201,
    y: 10.2009,
    width: 5.59818,
    height: 5.59818,
    rx: 2.79909,
    stroke: "url(#paint9_linear_2590_4847)",
    strokeOpacity: 0.5,
    strokeWidth: 0.401822
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_2590_4847)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 2,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#161718"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.2009,
    y: 2.20091,
    width: 5.59818,
    height: 5.59818,
    rx: 2.79909,
    stroke: "url(#paint10_linear_2590_4847)",
    strokeOpacity: 0.5,
    strokeWidth: 0.401822
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_2590_4847)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 83,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#161718"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.2009,
    y: 83.2009,
    width: 5.59818,
    height: 5.59818,
    rx: 2.79909,
    stroke: "url(#paint11_linear_2590_4847)",
    strokeOpacity: 0.5,
    strokeWidth: 0.401822
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_2590_4847)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 229,
    y: 147,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#161718"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.201,
    y: 147.201,
    width: 5.59818,
    height: 5.59818,
    rx: 2.79909,
    stroke: "url(#paint12_linear_2590_4847)",
    strokeOpacity: 0.5,
    strokeWidth: 0.401822
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_2590_4847)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 172,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#161718"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.201,
    y: 172.201,
    width: 5.59818,
    height: 5.59818,
    rx: 2.79909,
    stroke: "url(#paint13_linear_2590_4847)",
    strokeOpacity: 0.5,
    strokeWidth: 0.401822
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_2590_4847)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 128,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2590_4847",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 133,
    width: 14,
    height: 14
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 123,
    y: 133,
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2590_4847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.334 144.667C125.013 144.667 124.738 144.553 124.51 144.325C124.281 144.096 124.167 143.821 124.167 143.501V136.501C124.167 136.18 124.281 135.905 124.51 135.677C124.738 135.448 125.013 135.334 125.334 135.334H134.667C134.988 135.334 135.262 135.448 135.491 135.677C135.719 135.905 135.834 136.18 135.834 136.501V143.501C135.834 143.821 135.719 144.096 135.491 144.325C135.262 144.553 134.988 144.667 134.667 144.667H125.334ZM130 140.584L134.667 137.667V136.501L130 139.417L125.334 136.501V137.667L130 140.584Z",
    fill: "#111213"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_2590_4847)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 94,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2590_4847",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 199,
    y: 99,
    width: 14,
    height: 14
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 99,
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2590_4847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.083 109.499C202.918 109.499 202.78 109.443 202.668 109.332C202.556 109.22 202.5 109.081 202.5 108.916V107.749H210.083V102.499H211.25C211.415 102.499 211.554 102.555 211.666 102.667C211.778 102.779 211.833 102.917 211.833 103.083V111.833L209.5 109.499H203.083ZM200.167 108.916V100.749C200.167 100.584 200.223 100.446 200.334 100.334C200.446 100.222 200.585 100.166 200.75 100.166H208.333C208.499 100.166 208.637 100.222 208.749 100.334C208.861 100.446 208.917 100.584 208.917 100.749V105.999C208.917 106.165 208.861 106.303 208.749 106.415C208.637 106.527 208.499 106.583 208.333 106.583H202.5L200.167 108.916Z",
    fill: "#1C1B1F"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_d_2590_4847)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 54,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2590_4847",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 59,
    width: 14,
    height: 14
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 59,
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2590_4847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.637 71.25C121.422 71.25 120.222 70.9851 119.035 70.4552C117.849 69.9253 116.77 69.1743 115.798 68.2021C114.826 67.2299 114.075 66.1507 113.545 64.9646C113.015 63.7785 112.75 62.5778 112.75 61.3625C112.75 61.1875 112.808 61.0417 112.925 60.925C113.042 60.8083 113.188 60.75 113.363 60.75H115.725C115.861 60.75 115.983 60.7962 116.09 60.8885C116.197 60.9809 116.26 61.0903 116.279 61.2167L116.658 63.2583C116.678 63.4139 116.673 63.5451 116.644 63.6521C116.615 63.759 116.561 63.8514 116.483 63.9292L115.069 65.3583C115.263 65.7181 115.494 66.0656 115.761 66.401C116.029 66.7365 116.323 67.0597 116.644 67.3708C116.945 67.6722 117.261 67.9517 117.592 68.2094C117.922 68.467 118.272 68.7028 118.642 68.9167L120.012 67.5458C120.1 67.4583 120.214 67.3927 120.355 67.349C120.496 67.3052 120.635 67.2931 120.771 67.3125L122.783 67.7208C122.919 67.7597 123.031 67.8302 123.119 67.9323C123.206 68.0344 123.25 68.1486 123.25 68.275V70.6375C123.25 70.8125 123.192 70.9583 123.075 71.075C122.958 71.1917 122.812 71.25 122.637 71.25Z",
    fill: "#1C1B1F"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_d_2590_4847)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 26,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#B6B8BB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.201,
    y: 26.2009,
    width: 23.5982,
    height: 23.5982,
    rx: 11.7991,
    stroke: "url(#paint14_linear_2590_4847)",
    strokeOpacity: 0.5,
    strokeWidth: 0.401822
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2590_4847",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 165,
    y: 30,
    width: 16,
    height: 16
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 30,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2590_4847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173 45.334V44.0007H177.667V43.334H175V38.0007H177.667V37.334C177.667 36.0451 177.211 34.9451 176.3 34.034C175.389 33.1229 174.289 32.6673 173 32.6673C171.711 32.6673 170.611 33.1229 169.7 34.034C168.789 34.9451 168.333 36.0451 168.333 37.334V38.0007H171V43.334H168.333C167.967 43.334 167.653 43.2034 167.392 42.9423C167.131 42.6812 167 42.3673 167 42.0007V37.334C167 36.5118 167.158 35.7368 167.475 35.009C167.792 34.2812 168.222 33.6451 168.767 33.1007C169.311 32.5562 169.947 32.1257 170.675 31.809C171.403 31.4923 172.178 31.334 173 31.334C173.822 31.334 174.597 31.4923 175.325 31.809C176.053 32.1257 176.689 32.5562 177.233 33.1007C177.778 33.6451 178.208 34.2812 178.525 35.009C178.842 35.7368 179 36.5118 179 37.334V44.0007C179 44.3673 178.869 44.6812 178.608 44.9423C178.347 45.2034 178.033 45.334 177.667 45.334H173Z",
    fill: "#1C1B1F"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_d_2590_4847)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 83,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#B6B8BB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.2009,
    y: 83.2009,
    width: 19.5982,
    height: 19.5982,
    rx: 9.79909,
    stroke: "url(#paint15_linear_2590_4847)",
    strokeOpacity: 0.5,
    strokeWidth: 0.401822
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2590_4847",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 86,
    width: 14,
    height: 14
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 86,
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2590_4847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.5833 95.9465C55.011 95.7423 55.4412 95.5892 55.8739 95.4871C56.3065 95.385 56.7513 95.334 57.2083 95.334C57.5583 95.334 57.901 95.3632 58.2364 95.4215C58.5718 95.4798 58.9096 95.5673 59.2499 95.684V89.909C58.9291 89.7729 58.5961 89.6708 58.251 89.6027C57.9058 89.5347 57.5583 89.5007 57.2083 89.5007C56.7513 89.5007 56.2992 89.559 55.852 89.6757C55.4048 89.7923 54.9819 89.9673 54.5833 90.2007V95.9465ZM53.9999 97.6673C53.5333 97.2979 53.0277 97.0111 52.4833 96.8069C51.9388 96.6027 51.3749 96.5007 50.7916 96.5007C50.3833 96.5007 49.9822 96.5541 49.5885 96.6611C49.1947 96.768 48.818 96.9187 48.4583 97.1132C48.2541 97.2201 48.0572 97.2152 47.8676 97.0986C47.678 96.9819 47.5833 96.8118 47.5833 96.5882V89.559C47.5833 89.452 47.61 89.35 47.6635 89.2527C47.7169 89.1555 47.7971 89.0826 47.9041 89.034C48.361 88.8104 48.8301 88.6378 49.3114 88.5163C49.7926 88.3947 50.286 88.334 50.7916 88.334C51.3555 88.334 51.9072 88.4069 52.4468 88.5527C52.9864 88.6986 53.5041 88.9173 53.9999 89.209C54.4958 88.9173 55.0135 88.6986 55.553 88.5527C56.0926 88.4069 56.6444 88.334 57.2083 88.334C57.7138 88.334 58.2072 88.3947 58.6885 88.5163C59.1697 88.6378 59.6388 88.8104 60.0958 89.034C60.2027 89.0826 60.2829 89.1555 60.3364 89.2527C60.3898 89.35 60.4166 89.452 60.4166 89.559V96.5882C60.4166 96.8118 60.3218 96.9819 60.1322 97.0986C59.9426 97.2152 59.7458 97.2201 59.5416 97.1132C59.1819 96.9187 58.8051 96.768 58.4114 96.6611C58.0176 96.5541 57.6166 96.5007 57.2083 96.5007C56.6249 96.5007 56.061 96.6027 55.5166 96.8069C54.9721 97.0111 54.4666 97.2979 53.9999 97.6673Z",
    fill: "#1C1B1F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2590_4847",
    x: 25,
    y: -1.39271,
    width: 212,
    height: 212,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2590_4847"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.60729
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.920833 0 0 0 0 0.920833 0 0 0 0.34 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2590_4847"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2590_4847",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2590_4847",
    x: -10,
    y: -36.3927,
    width: 282,
    height: 282,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2590_4847"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.60729
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.920833 0 0 0 0 0.920833 0 0 0 0.34 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2590_4847"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2590_4847",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2590_4847",
    x: -34,
    y: -60.3927,
    width: 330,
    height: 330,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2590_4847"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.60729
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.920833 0 0 0 0 0.920833 0 0 0 0.34 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2590_4847"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2590_4847",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2590_4847",
    x: 88,
    y: 61.6073,
    width: 86,
    height: 86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2590_4847"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.60729
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.920833 0 0 0 0 0.920833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2590_4847"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2590_4847",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_2590_4847",
    x: 45,
    y: 121.607,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.60729
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.239216 0 0 0 0 0.666667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2590_4847"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2590_4847",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_2590_4847",
    x: 65,
    y: 28.6073,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.60729
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.239216 0 0 0 0 0.666667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2590_4847"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2590_4847",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_2590_4847",
    x: 138,
    y: 56.6073,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.60729
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.239216 0 0 0 0 0.666667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2590_4847"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2590_4847",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_2590_4847",
    x: 165,
    y: -17.3927,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2590_4847"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.60729
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.920833 0 0 0 0 0.920833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2590_4847"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2590_4847",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_2590_4847",
    x: 46,
    y: -25.3927,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2590_4847"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.60729
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.920833 0 0 0 0 0.920833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2590_4847"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2590_4847",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_2590_4847",
    x: -11,
    y: 55.6073,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2590_4847"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.60729
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.920833 0 0 0 0 0.920833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2590_4847"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2590_4847",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_2590_4847",
    x: 200,
    y: 119.607,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2590_4847"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.60729
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.920833 0 0 0 0 0.920833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2590_4847"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2590_4847",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_2590_4847",
    x: 72,
    y: 144.607,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2590_4847"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.60729
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.920833 0 0 0 0 0.920833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2590_4847"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2590_4847",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_2590_4847",
    x: 105,
    y: 117,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.239216 0 0 0 0 0.666667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2590_4847"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2590_4847",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_2590_4847",
    x: 181,
    y: 83,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.239216 0 0 0 0 0.666667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2590_4847"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2590_4847",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_2590_4847",
    x: 93,
    y: 43,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.239216 0 0 0 0 0.666667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2590_4847"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2590_4847",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_2590_4847",
    x: 148,
    y: 14.6073,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.60729
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.239216 0 0 0 0 0.666667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2590_4847"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2590_4847",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_2590_4847",
    x: 31,
    y: 71.6073,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.60729
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.239216 0 0 0 0 0.666667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2590_4847"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2590_4847",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2590_4847",
    x1: 98,
    y1: 138.305,
    x2: 176.215,
    y2: 126.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2590_4847",
    x1: 65.8462,
    y1: 172.705,
    x2: 220.271,
    y2: 149.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2590_4847",
    x1: 36.2308,
    y1: 204.39,
    x2: 260.848,
    y2: 169.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2590_4847",
    x1: 15.9231,
    y1: 226.116,
    x2: 288.673,
    y2: 184.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2590_4847",
    x1: 150.998,
    y1: 126.113,
    x2: 159.945,
    y2: 109.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2590_4847",
    x1: 119.154,
    y1: 115.674,
    x2: 147.231,
    y2: 111.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2590_4847",
    x1: 58.7692,
    y1: 142.526,
    x2: 68.7968,
    y2: 140.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2590_4847",
    x1: 78.7692,
    y1: 49.5263,
    x2: 88.7968,
    y2: 47.9888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2590_4847",
    x1: 151.769,
    y1: 77.5263,
    x2: 161.797,
    y2: 75.9888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2590_4847",
    x1: 194.462,
    y1: 15.7158,
    x2: 200.478,
    y2: 14.7933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2590_4847",
    x1: 75.4615,
    y1: 7.71579,
    x2: 81.4781,
    y2: 6.79326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2590_4847",
    x1: 18.4615,
    y1: 88.7158,
    x2: 24.4781,
    y2: 87.7933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2590_4847",
    x1: 229.462,
    y1: 152.716,
    x2: 235.478,
    y2: 151.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2590_4847",
    x1: 101.462,
    y1: 177.716,
    x2: 107.478,
    y2: 176.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2590_4847",
    x1: 162.846,
    y1: 48.8632,
    x2: 186.912,
    y2: 45.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2590_4847",
    x1: 45.5385,
    y1: 102.053,
    x2: 65.5936,
    y2: 98.9775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2590_4847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263,
    height: 185,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.9ef9bd4c7087b634a26288b2a1abbfef.svg";
export { ForwardRef as ReactComponent };